import React from 'react';
import _orderBy from 'lodash/orderBy';
import { MiniLoader } from '@pwc/pwc-deals-ui';
import UnableToLoadContent from '../../../features/analyses/common/UnableToLoadContent/UnableToLoadContent';
import AnalysisLibraryItem from './AnalysisLibraryItem';
// TODO: CRA Upgrade Tech Debt
import styles from './OneColumnLayout.module.scss';

const OneColumnLayout = ({
  items,
  projectId,
  analysisId,
  isLoading,
  hasError,
  isInMultipleColumnLayout = false,
}) => {
  const orderedItems = _orderBy(_orderBy(items, [(item) => item.order]), [
    (item) => item.analysisColumn,
  ]);

  return orderedItems.map((item) => {
    if (isLoading || !item.type)
      return (
        <div
          className={styles.miniLoaderHolder}
          key={`loader-${item.id}-${item.name}`}
        >
          <MiniLoader
            key={`${item.id}-${item.name}`}
            dataTestId="excel-content-loader"
          />
        </div>
      );

    if (hasError || item.type < 0) {
      const err = item.error || {};
      const data = item.data && typeof item.data !== 'string' ? item.data : {};

      return (
        <UnableToLoadContent
          apiErrorCode={err.apiErrorCode}
          errorCode={err.errorCode || err.apiErrorCode}
          data={{
            sharePointItemUrl: data.sharePointItemUrl,
          }}
          key={`${item.id}-${item.name}`}
          placeId="content-error-oneColumnLayout"
          projectId={projectId}
          type={err.type}
        />
      );
    }

    return (
      <AnalysisLibraryItem
        item={item}
        key={`${item.id}-${item.name}`}
        projectId={projectId}
        analysisId={analysisId}
        isLoading={isLoading}
        isInMultipleColumnLayout={isInMultipleColumnLayout}
      />
    );
  });
};

export default OneColumnLayout;
